var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNccaEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 13.582,
    viewBox: "0 0 15.999 13.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kfgjt0lufa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8",
    style: {
      fill: "#2162d5"
    },
    d: "M0 0h14.303v5.219H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "thvh4dny7b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9",
    style: {
      fill: "#2162d5"
    },
    d: "M0 0h6.773v2.961H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qwkme1swdc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10",
    style: {
      fill: "#2162d5"
    },
    d: "M0 0h6.722v2.928H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ingpvqi6yd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 11",
    style: {
      fill: "none"
    },
    d: "M0 0h.96v1.276H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kk5atrmfke"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12",
    style: {
      fill: "none"
    },
    d: "M0 0h.255v.26H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173476"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173405"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6136",
    d: "M193.532 5.373h-14.239a.535.535 0 0 1 .163-.23l.028-.021 6.6-5.008a.542.542 0 0 1 .656 0l6.6 5.008.028.021.02.018.015.014a.47.47 0 0 1 .042.046l.017.022a.5.5 0 0 1 .057.1l.012.03",
    transform: "translate(-178.413 -.001)",
    style: {
      fill: "#5b97ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6137",
    d: "M237.79 66.123h-12.426V54.848a.959.959 0 0 1 .959-.959h10.508a.959.959 0 0 1 .959.959z",
    transform: "translate(-223.666 -52.932)",
    style: {
      fill: "#c5dafb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6138",
    d: "M314.4 175.112h-9.131a.233.233 0 0 1-.233-.233v-.1a.233.233 0 0 1 .233-.233h9.131a.233.233 0 0 1 .233.233v.1a.233.233 0 0 1-.233.233",
    transform: "translate(-301.926 -171.448)",
    style: {
      fill: "#5b97ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6139",
    d: "M314.4 242.954h-9.131a.233.233 0 0 1-.233-.233v-.1a.233.233 0 0 1 .233-.233h9.131a.233.233 0 0 1 .233.233v.1a.233.233 0 0 1-.233.233",
    transform: "translate(-301.926 -238.085)",
    style: {
      fill: "#5b97ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6140",
    d: "M314.4 310.8h-9.131a.233.233 0 0 1-.233-.233v-.1a.233.233 0 0 1 .233-.233h9.131a.233.233 0 0 1 .233.233v.1a.233.233 0 0 1-.233.233",
    transform: "translate(-301.926 -304.721)",
    style: {
      fill: "#5b97ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6141",
    d: "M314.4 378.638h-9.131a.233.233 0 0 1-.233-.233v-.1a.233.233 0 0 1 .233-.233h9.131a.233.233 0 0 1 .233.233v.1a.233.233 0 0 1-.233.233",
    transform: "translate(-301.926 -371.359)",
    style: {
      fill: "#5b97ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6142",
    d: "M314.4 446.479h-9.131a.233.233 0 0 1-.233-.233v-.1a.233.233 0 0 1 .233-.233h9.131a.233.233 0 0 1 .233.233v.1a.233.233 0 0 1-.233.233",
    transform: "translate(-301.926 -437.995)",
    style: {
      fill: "#5b97ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6143",
    d: "M184.638 287.112a.353.353 0 0 1-.074.061l-6.513 4.019h-.029a.523.523 0 0 1-.155-.023l-.02-.007a.531.531 0 0 1-.221-.146l-.017-.019a.5.5 0 0 1-.045-.063l-.013-.022-.012-.023a.534.534 0 0 1-.053-.232v-7.489a.534.534 0 0 1 .2-.414l.028-.021a.532.532 0 0 1 .309-.1h.122l.572.353 5.272 3.253.2.122.378.233a.352.352 0 0 1 .074.061.343.343 0 0 1 0 .459",
    transform: "translate(-176.638 -277.61)",
    style: {
      fill: "#3b82f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6144",
    d: "M582.409 283.167V290.684a.117.117 0 0 1 0 .013V290.768a.018.018 0 0 1 0 .007.062.062 0 0 1 0 .009v.017c0 .01-.006.019-.009.028l-.005.014v.012a.373.373 0 0 1-.016.035l-.006.012-.007.011-.006.011-.014.022-.009.013-.022.028-.017.02-.018.019-.009.009-.008.007-.01.009-.026.021-.021.015h-.007l-.012.007-.01.006-.01.006a.488.488 0 0 1-.076.035h-.006l-.019.006-.033.009H581.881l-6.513-4.019a.337.337 0 0 1-.073-.061.342.342 0 0 1 0-.459.337.337 0 0 1 .073-.061l.378-.233.2-.122 5.272-3.253.572-.353H582.001l.031.006h.008l.037.01.034.012a.447.447 0 0 1 .046.021l.024.013a.349.349 0 0 1 .04.026l.028.021.02.018.015.014a.466.466 0 0 1 .042.046l.017.022a.5.5 0 0 1 .057.1l.012.03c.006.016.011.033.015.049s0 .016.006.024 0 .013 0 .019v.02a.2.2 0 0 1 0 .023.145.145 0 0 1 0 .02v.028",
    transform: "translate(-567.259 -277.611)",
    style: {
      fill: "#3b82f4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12941",
    transform: "translate(.848 8.362)",
    style: {
      clipPath: "url(#kfgjt0lufa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6145",
    d: "M191.789 475.371v.078a.548.548 0 0 1-.536.559h-13.231a.548.548 0 0 1-.536-.559v-.078l6.806-4.478a.625.625 0 0 1 .692 0z",
    transform: "translate(-177.486 -470.789)",
    style: {
      fill: "#2162d5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6146",
    d: "M191.789 487.516v.075a.536.536 0 0 1-.536.536h-13.231a.536.536 0 0 1-.536-.536v-.075l6.806-4.29a.648.648 0 0 1 .692 0z",
    transform: "translate(-176.638 -474.546)",
    style: {
      fill: "#5b97ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6147",
    d: "M309.254 107.27h-3.982a.233.233 0 0 1-.233-.233v-.1a.233.233 0 0 1 .233-.233h3.982a.233.233 0 0 1 .233.233v.1a.233.233 0 0 1-.233.233",
    transform: "translate(-301.926 -104.811)",
    style: {
      fill: "#f4b545"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173406"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12944",
    transform: "translate(.418 6.376)",
    style: {
      clipPath: "url(#thvh4dny7b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6148",
    d: "m30.173 213.009-6.433-.015a.167.167 0 0 0-.167.166l-.006 2.613a.167.167 0 0 0 .166.167l6.433.015a.167.167 0 0 0 .167-.166l.006-2.613a.167.167 0 0 0-.166-.167",
    transform: "translate(-23.567 -212.994)",
    style: {
      fill: "#2162d5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6149",
    d: "m6.6 193.744-6.433-.015a.167.167 0 0 1-.167-.166l.006-2.613a.167.167 0 0 1 .167-.166l6.433.015a.167.167 0 0 1 .166.167l-.006 2.613a.167.167 0 0 1-.167.166",
    transform: "translate(0 -184.802)",
    style: {
      fill: "#f4b545"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6150",
    d: "M18.6 206.15a1.225 1.225 0 1 1-1.222-1.228 1.225 1.225 0 0 1 1.222 1.228",
    transform: "translate(-15.862 -198.69)",
    style: {
      fill: "#ffdca4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6151",
    d: "M51.612 308.239h-.021a1.044 1.044 0 0 1-.567-.19.577.577 0 0 1 .356-.295.51.51 0 0 1 .079-.016.56.56 0 0 1 .076-.005h.208a.568.568 0 0 1 .075.005.51.51 0 0 1 .079.017.573.573 0 0 1 .278.18.583.583 0 0 1 .071.106 1.05 1.05 0 0 1-.554.2h-.082z",
    transform: "translate(-50.118 -299.674)",
    style: {
      fill: "#f4b545"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6152",
    d: "M54.893 217.861s-.063-.7.32-.715.541-.11.633-.077.161.671.136.795-1.089 0-1.089 0",
    transform: "translate(-53.914 -210.614)",
    style: {
      fill: "#e09f36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6153",
    d: "M75.915 293.846v.2a.182.182 0 0 1-.358 0v-.2a.136.136 0 0 1 .037-.091l.018-.017a.177.177 0 0 1 .041-.025.207.207 0 0 1 .168 0 .179.179 0 0 1 .041.025l.016.015a.136.136 0 0 1 .037.092",
    transform: "translate(-74.214 -285.885)",
    style: {
      fill: "#f4cb95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6154",
    d: "M59.3 237.937v.286a.469.469 0 0 1-.308.438v.075a.462.462 0 0 1-.16.028H58.8a.464.464 0 0 1-.16-.029v-.076a.469.469 0 0 1-.306-.44v-.286a.469.469 0 0 1 .469-.464h.038a.465.465 0 0 1 .29.1.467.467 0 0 1 .176.364",
    transform: "translate(-57.296 -230.661)",
    style: {
      fill: "#d8a471"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6155",
    d: "M59.31 233.7v.359a.463.463 0 0 1-.071.245.371.371 0 0 1-.023.032.414.414 0 0 1-.03.037.465.465 0 0 1-.345.152H58.8a.468.468 0 0 1-.466-.469v-.373a.467.467 0 0 1 .164-.341.427.427 0 0 1 .049-.036.463.463 0 0 1 .256-.076h.038a.454.454 0 0 1 .2.048.38.38 0 0 1 .036.02.448.448 0 0 1 .041.028.467.467 0 0 1 .184.372",
    transform: "translate(-57.3 -226.495)",
    style: {
      fill: "#f4cb95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6156",
    d: "M113.307 259.9a.187.187 0 0 1-.188.187v-.374a.185.185 0 0 1 .073.015.187.187 0 0 1 .113.172",
    transform: "translate(-111.11 -252.512)",
    style: {
      fill: "#edc28e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6157",
    d: "M113.242 263.846a.116.116 0 0 1-.116.116v-.232a.116.116 0 0 1 .116.116",
    transform: "translate(-111.117 -256.453)",
    style: {
      fill: "#d8a471"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6158",
    d: "M48 259.59v.374a.187.187 0 0 1-.041-.37h.038",
    transform: "translate(-46.966 -252.387)",
    style: {
      fill: "#edc28e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6159",
    d: "M51.827 263.72a.116.116 0 0 0 .116.116v-.236a.116.116 0 0 0-.116.116",
    transform: "translate(-50.906 -256.329)",
    style: {
      fill: "#d8a471"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6160",
    d: "M86.3 237.465v.359a.463.463 0 0 1-.071.245.371.371 0 0 1-.023.032c.095-.677-.019-.776-.18-.775s-.212-.212-.212-.212l.26-.05a.438.438 0 0 1 .041.028.467.467 0 0 1 .184.372",
    transform: "translate(-84.291 -230.261)",
    style: {
      fill: "#e5b67f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6161",
    d: "m86.674 308.968.045.078-.17.2h-.039l.138-.33.023-.054V308.756l.1.169-.094.042z",
    transform: "translate(-84.973 -300.679)",
    style: {
      fill: "#cc8e2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6162",
    d: "M73.912 312.925h.039l.023-.037.123-.2v-.06l.043-.042-.021-.081a.189.189 0 0 1-.011.017.386.386 0 0 1-.133.126.232.232 0 0 1-.046.018.239.239 0 0 1-.062-.028.377.377 0 0 1-.116-.118.181.181 0 0 1-.011-.017l-.022.081.043.042v.06l.105.173.04.066h.007z",
    transform: "translate(-72.407 -304.36)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6163",
    d: "m86.39 308.286.04.08-.2.2h-.016l.133-.317.036-.085v-.1l.1.181-.1.032z",
    transform: "translate(-84.685 -299.999)",
    style: {
      fill: "#e09f36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6164",
    d: "M70.192 309.2h-.021l-.177-.2.046-.078h-.005l-.094-.043.1-.168v.1l.023.056.137.331h-.01z",
    transform: "translate(-68.698 -300.634)",
    style: {
      fill: "#cc8e2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6165",
    d: "m70.192 308.518-.2-.2.04-.08.005-.01-.1-.033.1-.18v.1l.036.086.132.318h-.015z",
    transform: "translate(-68.698 -299.953)",
    style: {
      fill: "#e09f36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6166",
    d: "M59.191 229.326a2.461 2.461 0 0 0-.279-.071.809.809 0 0 0-.193.027.883.883 0 0 0-.225.118l-.026.048a.163.163 0 0 0-.029.036s0 .019-.007.032l-.021.04.018-.006.012.038a.4.4 0 0 1 .128-.111.372.372 0 0 1 .337.026.748.748 0 0 0 .506.055z",
    transform: "translate(-57.374 -222.591)",
    style: {
      fill: "#e09f36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6167",
    d: "m178.863 217.062-2.807-.007a.132.132 0 0 1-.131-.132v-.007a.132.132 0 0 1 .132-.131l2.807.006a.132.132 0 0 1 .131.132v.007a.132.132 0 0 1-.132.131",
    transform: "translate(-172.799 -210.342)",
    style: {
      fill: "#e29d2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6168",
    d: "m178.787 250.223-2.807-.006a.132.132 0 0 1-.131-.132v-.007a.132.132 0 0 1 .132-.131l2.807.007a.132.132 0 0 1 .131.132v.007a.132.132 0 0 1-.132.131",
    transform: "translate(-172.724 -242.914)",
    style: {
      fill: "#ffdca4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6169",
    d: "m178.71 283.384-2.807-.007a.132.132 0 0 1-.131-.132v-.007a.132.132 0 0 1 .132-.131l2.807.007a.132.132 0 0 1 .131.132v.007a.132.132 0 0 1-.132.132",
    transform: "translate(-172.65 -275.486)",
    style: {
      fill: "#ffdca4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6170",
    d: "m178.633 316.545-2.807-.006a.132.132 0 0 1-.131-.132v-.007a.132.132 0 0 1 .132-.131l2.807.007a.132.132 0 0 1 .131.132v.007a.132.132 0 0 1-.132.131",
    transform: "translate(-172.573 -308.058)",
    style: {
      fill: "#ffdca4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173407"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12947",
    transform: "translate(9.277 9.803)",
    style: {
      clipPath: "url(#qwkme1swdc)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6171",
    d: "M130.242 429.515h-6.391a.166.166 0 0 0-.165.165v2.6a.166.166 0 0 0 .165.165h6.391a.166.166 0 0 0 .165-.165v-2.6a.166.166 0 0 0-.165-.166",
    transform: "translate(-123.685 -429.514)",
    style: {
      fill: "#2162d5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6172",
    d: "M106.044 405.975h-6.392a.166.166 0 0 1-.165-.166v-2.6a.166.166 0 0 1 .166-.165h6.391a.166.166 0 0 1 .165.165v2.6a.166.166 0 0 1-.165.165",
    transform: "translate(-90.639 -393.714)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6173",
    d: "M276.909 430.263h-2.789a.131.131 0 0 1-.131-.131v-.006a.131.131 0 0 1 .131-.131h2.789a.131.131 0 0 1 .131.131v.007a.131.131 0 0 1-.131.131",
    transform: "translate(-262.042 -420.183)",
    style: {
      fill: "#3b82f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6174",
    d: "M276.9 463.206h-2.789a.131.131 0 0 1-.131-.131v-.007a.131.131 0 0 1 .131-.131h2.789a.131.131 0 0 1 .131.131v.007a.131.131 0 0 1-.131.131",
    transform: "translate(-262.037 -452.54)",
    style: {
      fill: "#ecf3fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6175",
    d: "M276.9 496.149h-2.789a.131.131 0 0 1-.131-.131v-.007a.131.131 0 0 1 .131-.131h2.789a.131.131 0 0 1 .131.131v.007a.131.131 0 0 1-.131.131",
    transform: "translate(-262.031 -484.898)",
    style: {
      fill: "#ecf3fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6176",
    d: "M276.892 529.091H274.1a.131.131 0 0 1-.131-.131v-.007a.131.131 0 0 1 .131-.131h2.789a.131.131 0 0 1 .131.131v.007a.131.131 0 0 1-.131.131",
    transform: "translate(-262.025 -517.255)",
    style: {
      fill: "#ecf3fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6177",
    d: "M117.818 417.522a1.228 1.228 0 1 1-1.228-1.229 1.228 1.228 0 0 1 1.228 1.229",
    transform: "translate(-106.232 -406.725)",
    style: {
      fill: "#ecf3fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6178",
    d: "M152.092 513.88a.966.966 0 0 1-.219.127.939.939 0 0 1-.123.042.98.98 0 0 1-.372.027.971.971 0 0 1-.48-.2.566.566 0 0 1 .342-.275.52.52 0 0 1 .078-.016.53.53 0 0 1 .071 0h.2a.54.54 0 0 1 .071 0 .534.534 0 0 1 .078.016.566.566 0 0 1 .342.275",
    transform: "translate(-141.137 -502.288)",
    style: {
      fill: "#f4b545"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6179",
    d: "M153.448 430.819v.659a.263.263 0 0 1-.263.263h-.619a.263.263 0 0 1-.263-.263v-.659a.535.535 0 0 1 .572-.558.68.68 0 0 1 .295.064.487.487 0 0 1 .275.439v.056",
    transform: "translate(-142.519 -420.444)",
    style: {
      fill: "#15315e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6180",
    d: "M174.918 499.873v.194a.179.179 0 0 1-.354 0v-.194a.134.134 0 0 1 .036-.09l.017-.016a.178.178 0 0 1 .04-.025.205.205 0 0 1 .165 0 .175.175 0 0 1 .04.025l.016.015a.134.134 0 0 1 .036.09",
    transform: "translate(-164.384 -488.674)",
    style: {
      fill: "#f4b698"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12950",
    transform: "translate(9.877 10.065)",
    style: {
      clipPath: "url(#ingpvqi6yd)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6181",
    d: "M.96.459v.282a.463.463 0 0 1-.3.433v.074a.456.456 0 0 1-.158.028H.464a.455.455 0 0 1-.158-.028v-.074a.463.463 0 0 1-.3-.433V.459A.463.463 0 0 1 .467 0h.028a.458.458 0 0 1 .287.1.461.461 0 0 1 .174.358"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6182",
    d: "M158.463 440.548v.354a.458.458 0 0 1-.082.261.5.5 0 0 1-.039.049.464.464 0 0 1-.182.122.456.456 0 0 1-.158.028h-.038a.455.455 0 0 1-.158-.028.463.463 0 0 1-.3-.433v-.367a.46.46 0 0 1 .161-.337.476.476 0 0 1 .048-.036.457.457 0 0 1 .252-.075H158a.458.458 0 0 1 .278.094.467.467 0 0 1 .137.168.454.454 0 0 1 .045.2",
    transform: "translate(-147.625 -430.096)",
    style: {
      fill: "#f4b698"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6183",
    d: "M211.724 466.341a.185.185 0 0 1-.185.185v-.369a.184.184 0 0 1 .072.015.185.185 0 0 1 .112.17",
    transform: "translate(-200.702 -455.702)",
    style: {
      fill: "#f4b698"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6184",
    d: "M211.653 470.229a.114.114 0 0 1-.114.114v-.229a.114.114 0 0 1 .114.114",
    transform: "translate(-200.702 -459.591)",
    style: {
      fill: "#e29586"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6185",
    d: "m170.664 514.777-.138.471a.962.962 0 0 1-.117.007.977.977 0 0 1-.117-.007l-.138-.471h.1l.154.159.154-.159z",
    transform: "translate(-160.052 -503.46)",
    style: {
      fill: "#15315e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6186",
    d: "M147.3 466.147v.369a.185.185 0 0 1-.041-.365h.037",
    transform: "translate(-137.42 -455.693)",
    style: {
      fill: "#f4b698"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6187",
    d: "M151.071 470.221a.114.114 0 0 0 .114.114v-.229a.114.114 0 0 0-.114.114",
    transform: "translate(-141.308 -459.582)",
    style: {
      fill: "#e29586"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6188",
    d: "M199 537.44a.946.946 0 0 1-.123.042v-.042z",
    transform: "translate(-188.262 -525.72)",
    style: {
      fill: "#15315e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12953",
    transform: "translate(10.358 11.317)",
    style: {
      clipPath: "url(#kk5atrmfke)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6189",
    d: "m184.512 514.942.137.1.118-.26z",
    transform: "translate(-184.512 -514.779)",
    style: {
      fill: "#363636"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6190",
    d: "m184.767 513.609-.12.251-.135-.088.158-.163.021-.021z",
    transform: "translate(-174.154 -502.291)",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12956",
    transform: "translate(10.102 11.317)",
    style: {
      clipPath: "url(#kk5atrmfke)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6191",
    d: "m170.155 514.775.117.26.138-.1z",
    transform: "translate(-170.155 -514.775)",
    style: {
      fill: "#363636"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6192",
    d: "m170.411 513.768-.135.088-.12-.251.077-.021.021.021z",
    transform: "translate(-160.054 -502.288)",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6193",
    d: "M200.324 436.773c-.344.025-.311-.286-.275-.439a.487.487 0 0 1 .275.439",
    transform: "translate(-189.394 -426.41)",
    style: {
      fill: "#15315e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6194",
    d: "M153.456 437.148a.439.439 0 0 1-.344.232c-.213 0-.552.128-.563.341s-.267-.649.381-.716.526.143.526.143",
    transform: "translate(-142.701 -427.055)",
    style: {
      fill: "#15315e"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNccaEmail);
export default __webpack_public_path__ + "static/media/NCCA-Email.6f6498ce5ad51cd0524142a9c471349b.svg";
export { ForwardRef as ReactComponent };